import Button, { ButtonProps } from '@components/Button/Button';
import { useMediaQueries } from '@utils/mediaQueries/mediaQueries';
import { Container } from './MobileStickyButton.styles';

const MobileStickyButton: React.FC<ButtonProps> = ({
  children,
  ...restProps
}) => {
  const { sm: isMobile } = useMediaQueries();

  return (
    <Container>
      <Button fullWidth={isMobile} {...restProps}>
        {children}
      </Button>
    </Container>
  );
};

export default MobileStickyButton;
